<div class="container mt-3">
  <h4 class="text-secondary mb-3" id="monitoringPerformanceTitle">Monitoring pour la performances des requêtes</h4>
  <p class="col-12 form-text text-secondary">
    entrer les dates pour exporter au format CSV une liste des requêtes détectées comme “lentes” ainsi que leur heure d’exécution, l’utilisateur à
    l’origine de la requête et le temps moyen mesuré. Ces informations permettent d’identifier rapidement les endpoints à optimiser afin d’améliorer
    les performances globales de l’application.
  </p>
  <form [formGroup]="monitoringForm" (ngSubmit)="onSubmit()">
    <div class="col-6 d-flex flex-row">
      <div class="text-secondary m-1">
        <label for="benginDate required">Date de début</label>
        <app-datepicker
          type="date"
          id="beginDate"
          formControlName="beginDate"
          [invalid]="submitted && (monitoringForm.controls?.beginDate?.invalid || monitoringForm.errors?.datesOrder)"
        ></app-datepicker>
        @if (submitted && monitoringForm.controls?.beginDate?.errors?.dateFormat) {
          <small class="form-text text-danger"
            >La date de début est invalide.</small
            >
          }
          @if (submitted && monitoringForm.controls?.beginDate?.errors?.required) {
            <small class="form-text text-danger"
              >La date de début est requise.</small
              >
            }
          </div>

          <div class="text-secondary -3 m-1">
            <label for="endDate required">Date de fin</label>
            <app-datepicker
              type="date"
              id="endDate"
              formControlName="endDate"
              [invalid]="submitted && (monitoringForm.controls?.endDate?.invalid || monitoringForm.errors?.datesOrder)"
            ></app-datepicker>
            @if (submitted && monitoringForm.controls?.endDate?.errors?.dateFormat) {
              <small class="form-text text-danger"
                >La date de fin est invalide.</small
                >
              }
              @if (submitted && monitoringForm.controls?.endDate?.errors?.required) {
                <small class="form-text text-danger"
                  >La date de fin est requise.</small
                  >
                }
                @if (submitted && monitoringForm.errors?.datesOrder) {
                  <small class="form-text text-danger"
                    >La date de début est incohérente avec la date de fin.</small
                    >
                  }
                </div>
              </div>

              <div class="col-6 align-items-end">
                <button type="submit" class="btn btn-primary m-1">Exporter</button>
              </div>
            </form>
          </div>
